import type { YYYYMMDateString } from "../../common/dateStrings";

export class UserMetricsConfigJSON {
  reportPeriod: {
    start: YYYYMMDateString;
    end: YYYYMMDateString;
  };
}
